/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Superseded_TitleInputs */

const en_us2_draft_superseded_title = /** @type {(inputs: Draft_Superseded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This draft was replaced`)
};

const pt_br2_draft_superseded_title = /** @type {(inputs: Draft_Superseded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este rascunho foi substituído`)
};

const es_419_draft_superseded_title = /** @type {(inputs: Draft_Superseded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este borrador fue reemplazado`)
};

const pt_pt2_draft_superseded_title = /** @type {(inputs: Draft_Superseded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este rascunho foi substituído`)
};

const fr_fr2_draft_superseded_title = /** @type {(inputs: Draft_Superseded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce brouillon a été remplacé`)
};

const de_de2_draft_superseded_title = /** @type {(inputs: Draft_Superseded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Entwurf wurde ersetzt`)
};

const it_it2_draft_superseded_title = /** @type {(inputs: Draft_Superseded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa bozza è stata sostituita`)
};

/**
* | output |
* | --- |
* | "This draft was replaced" |
*
* @param {Draft_Superseded_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_superseded_title = /** @type {((inputs?: Draft_Superseded_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Superseded_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_superseded_title(inputs)
	if (locale === "es-419") return es_419_draft_superseded_title(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_superseded_title(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_superseded_title(inputs)
	if (locale === "de-DE") return de_de2_draft_superseded_title(inputs)
	if (locale === "it-IT") return it_it2_draft_superseded_title(inputs)
	return en_us2_draft_superseded_title(inputs)
});
export { draft_superseded_title as "draft.superseded_title" }